import { useMediaQuery } from './use-media-query';

export function useDevice() {
  const isMobile = useMediaQuery('(width < 768px)');

  return { isMobile };
}
